<template>
  <div class="page" :class="{'is-mobile' : $vuetify.breakpoint.mobile}">
    <div class="content">
      <v-container fluid>
        <DetalheCompradorDialog :item="item" v-model="detalheDialogOpened"/>
        <v-row>
          <v-col cols="12" sm="4">
            <span class="titulo">Olá, {{userName}},</span>
            <br/>
            <span class="sub-titulo">Como você está se sentindo hoje?</span>
          </v-col>
        </v-row>
        <!-- Inicio filtro -->
        <v-row>
          <v-col cols="12">
            <v-card class="mb-4" outlined>
              <v-card-title class="d-flex justify-space-between align-center">
                <span class="titulo">Filtros</span>
                <div>
                  <v-btn icon @click="showFilters = !showFilters" :title="showFilters ? 'Esconder filtros' : 'Exibir filtros'">
                    <v-icon>{{ showFilters ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                  </v-btn>
                  <v-btn color="primary" outlined class="ml-2" @click="clearFilters" title="Limpar filtros">
                    <v-icon left>mdi-filter-remove</v-icon> Limpar
                  </v-btn>
                </div>
              </v-card-title>
              <v-expand-transition>
                <v-card-text class="py-4 flex-grow-1" 
                  v-show="showFilters">
                  <v-row>
                    <v-col cols="12" sm="3">
                      <search-box
                          label="CNPJ"
                          popup-label="Selecione um CNPJ"
                          :chave.sync="localSearch.cnpjAux.chave"
                          :valor.sync="localSearch.cnpjAux.valor"
                          :hidden-clear="false"
                          :value="cnpj"
                          :loader-fn="loadCnpj"
                          item-key="chave"
                          item-text="valor">
                        <template v-slot:empty>
                          <p class="ma-2">
                            Nenhum CNPJ encontrado
                          </p>
                        </template>
                      </search-box>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <lookup-dominio label="Estado"
                                      :hidden-clear="false"
                                      v-model="localSearch.estadoAux"
                                      :type="lookups.estado"/>
                    </v-col>  
                    <v-col cols="12" sm="3">
                      <search-box ref="comboCidades"
                          label="Cidades"
                          popup-label="Selecione uma Cidade"
                          :chave.sync="localSearch.cidadeAux.chave"
                          :valor.sync="localSearch.cidadeAux.valor"
                          :hidden-clear="false"
                          :value="cidade"
                          :loader-fn="loadCidades"
                          item-key="chave"
                          item-text="valor">
                        <template v-slot:empty>
                          <p class="ma-2">
                            Nenhuma Cidade encontrada
                          </p>
                        </template>
                      </search-box>
                    </v-col>
                    <v-col cols="12" md="3">
                      <search-box  ref="comboAtividadeEconomica"
                          label="Atividade Econômica"
                          popup-label="Selecione um Atividade Econômica"
                          :id.sync="localSearch.atividadeEconomica.id"
                          :descricao.sync="localSearch.atividadeEconomica.descricao"
                          :hidden-clear="true"
                          :value="atividadeEconomica"
                          :loader-fn="loadAtividadeEconomica"
                          item-key="id"
                          item-text="descricao">
                        <template v-slot:empty>
                          <p class="ma-2">
                            Nenhum Atividade Econômica encontrada
                          </p>
                        </template>
                      </search-box>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-expand-transition>
            </v-card>
          </v-col>
        </v-row>
        <!-- Fim filtro -->
        <v-row>         
          <v-col cols="12" sm="6">
            <PainelCard :title="totalCompradorPorAtividadeEconomica.tituloGrafico" corTitulo="#188BC6" corFundo="#FFFFFF"
              :loading="totalCompradorPorAtividadeEconomica.isLoading" :minHeight="250" icon="mdi-briefcase-arrow-left-right">
              <apexchart ref="totalCompradorPorAtividadeEconomica"
                type="donut"
                :height="200"
                :options="totalCompradorPorAtividadeEconomica.chartOptions"
                :series="totalCompradorPorAtividadeEconomica.series"
              />
            </PainelCard>
          </v-col>
          <v-col cols="12" sm="6">
            <PainelCard :title="totalCompradorPorEstado.tituloGrafico" corTitulo="#188BC6" corFundo="#FFFFFF"
              :loading="totalCompradorPorEstado.isLoading" :minHeight="250" icon="mdi-map-legend">
              <apexchart ref="totalCompradorPorEstado"
                type="bar"
                :height="200"
                :options="totalCompradorPorEstado.chartOptions"
                :series="totalCompradorPorEstado.series"
              />
            </PainelCard>
          </v-col>
          <v-col cols="12" sm="12">
            <PainelCard :title="totalCompradorPorCidade.tituloGrafico" corTitulo="#188BC6" corFundo="#FFFFFF"
              :loading="totalCompradorPorCidade.isLoading" :minHeight="250" icon="mdi-map-marker-outline">
              <apexchart ref="totalCompradorPorCidade"
                type="bar"
                :height="200"
                :options="totalCompradorPorCidade.chartOptions"
                :series="totalCompradorPorCidade.series"
              />
            </PainelCard>
          </v-col>
          <v-col cols="12" sm="12">
            <PainelCard title="Lista de Compradores" corTitulo="#188BC6" corFundo="#FFFFFF"
              :loading="false" :minHeight="250" icon="mdi-list-box-outline">
              <CompradorDataTable ref="dataTableComprador"
                @click:verDetalhe="verDetalhe"
                :view-actions="false"
                :search-values="searchValuesLista"/>
            </PainelCard>
          </v-col> 
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import {findGraficoComprador} from "../../api/painel";
import {ItemDeDominio} from "../../api/itemsDominio";
import LookupDominio from "../../components/shared/common/LookupDominio";
import CompradorDataTable from "../../components/shared/datatables/CompradorDataTable";
import DetalheCompradorDialog from "../../components/shared/dialogs/DetalheCompradorDialog";
import PainelCard from "./components/PainelCard";
import SearchBox from "../../components/shared/common/SearchBox";
import {mapActions, mapGetters} from "vuex";
import {ApiError} from "../../api/core";
//PKs
import {findOne as findOneComprador, listaCnpj, listaCidades} from "../../api/comprador";
import {findAll as findAllAtividadeEconomica} from "../../api/atividadeEconomica";

export default {
  name: "Painel",
  components: {DetalheCompradorDialog, CompradorDataTable, PainelCard, SearchBox, LookupDominio},
  data() {
    return {
      localSearch: {
        cnpjAux: {
          chave: null,
          valor: null
        },
        estadoAux: null,
        cidadeAux: {
          chave: null,
          valor: null
        },
        atividadeEconomica: {
          id: null,
          descricao: null
        },
      },
      item: null,
      loading: false,
      searchValuesLista: {
        qtdRegPorPag: 20,
        cnpj: null,
        cidade: null,
        estado: null,
        idAtividadeEconomica: null,
      },
      detalheDialogOpened: false,
      lookups: {
        estado: ItemDeDominio.COMBO_ESTADO, 
      },
      totalCompradorPorAtividadeEconomica: {
        isLoading: false,
        tituloGrafico: "Compradores Por Atividade Econômica",
        series: [],
        chartOptions: {
          chart: {
            type: 'donut',
            height: 420,
          },
          labels: [],
          dataLabels: {
            enabled: true,
            formatter: (val) => `${val.toFixed(1)}%`
          },
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: true,
                  total: {
                    show: true,
                    label: 'Total',
                    formatter: function (w) {
                      return w.globals.seriesTotals.reduce((a, b) => a + b, 0)
                    }
                  }
                }
              }
            }
          },
          legend: {
            position: 'bottom',
            horizontalAlign: 'center'
          },
          responsive: [{
            breakpoint: 400,
            options: {
              chart: {
                height: 300,
                position: 'left',
              },
            }
          }]          
        }
      },
      totalCompradorPorEstado: {
        isLoading: false,
        tituloGrafico: "Compradores Por Estado",
        series: [{
          name: 'Compradores',
          data: []
        }],
        chartOptions: {
          chart: {
            type: 'bar',
            height: 420,
          },
          xaxis: {
            categories: [],
            title: {
              text: 'Estado'
            }
          },
          dataLabels: {
            enabled: true
          },
          plotOptions: {
            bar: {
              borderRadius: 4,
              horizontal: false,
            }
          },
          legend: {
            position: 'bottom',
            horizontalAlign: 'center'
          },
          responsive: [{
            breakpoint: 400,
            options: {
              chart: {
                height: 300,
                position: 'left',
              },
            }
          }]          
        }
      },
      totalCompradorPorCidade: {
        isLoading: false,
        tituloGrafico: "Compradores Por Cidade",
        series: [{
          name: 'Compradores',
          data: []
        }],
        chartOptions: {
          chart: {
            type: 'bar',
            height: 420,
          },
          xaxis: {
            categories: [],
            title: {
              text: 'Cidade'
            }
          },
          dataLabels: {
            enabled: false
          },
          plotOptions: {
            bar: {
              borderRadius: 4,
              horizontal: false,
            }
          },
          legend: {
            position: 'bottom',
            horizontalAlign: 'center'
          },
          responsive: [{
            breakpoint: 400,
            options: {
              chart: {
                height: 300,
                position: 'left',
              },
            }
          }]          
        }
      },
      showFilters: false,
    }
  },
  computed: {
    ...mapGetters('auth',['user','isAuthenticated', 'nivelUsuarioLogado']),
    userName: {
      get() {
        return this.user?.nome;
      }
    },
    cnpj(){
      if (this.localSearch.cnpjAux.chave == null) return null;
      return {
        chave: this.localSearch.cnpjAux.chave,
        valor: this.localSearch.cnpjAux.valor
      }      
    },
    cidade(){
      if (this.localSearch.cidadeAux.chave == null) return null;
      return {
        chave: this.localSearch.cidadeAux.chave,
        valor: this.localSearch.cidadeAux.valor
      }      
    },
    atividadeEconomica(){
      if (this.localSearch.atividadeEconomica.id == null) return null;
      return {
        id: this.localSearch.atividadeEconomica.id,
        descricao: this.localSearch.atividadeEconomica.descricao
      }      
    },
  },
  watch: {
    'localSearch.estadoAux': {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$refs.comboCidades.resetValues();
          this.$refs.comboCidades.search();
          this.searchValuesLista.estado = newValue;
          this.refresh();
        }
      }
    },
    'localSearch.cnpjAux.chave': {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.searchValuesLista.cnpj = newValue;
          this.refresh();
        }
      }
    },
    'localSearch.cidadeAux.chave': {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.searchValuesLista.cidade = newValue;
          this.refresh();
        }
      }
    },
    'localSearch.atividadeEconomica.id': {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.searchValuesLista.idAtividadeEconomica = newValue;
          this.refresh();
        }
      }
    },
  }, 
  methods: {
    ...mapActions('itemsDominio', ['fetch']),
    loadCnpj(page, search) {
      return listaCnpj(page, {});
    },
    loadCidades(page, search) {
      return listaCidades(page, {
        cidade: search,
        estado: this.localSearch.estadoAux,
      });
    },
    loadAtividadeEconomica(page, search) {
      return findAllAtividadeEconomica(page, {
        descricao: search
      })
    },
    async verDetalhe(objeto) {
      try {
        this.loading = true;
        const comprador = await findOneComprador(objeto.id);
        this.item = comprador.dados[0];
        this.detalheDialogOpened = true;
      } catch (err) {
        if (err instanceof ApiError) {
          this.$toast.error(err.message, {
            timeout: 6000
          });
        } else {           
          this.$toast.error(`Não foi possível recuperar os dados do Comprador. Tente Novamente mais tarde. ${err}`, {
            timeout: 6000
          });
        }
      } finally {
        this.loading = false;
      }
    }, 

    async refresh() {
      const self = this;

      this.totalCompradorPorAtividadeEconomica.isLoading = true;
      findGraficoComprador(1, {
        tipoSaida: 'atividadeEconomica',
        cnpj: this.localSearch.cnpjAux.chave,
        cidade: this.localSearch.cidadeAux.chave,
        estado: this.localSearch.estadoAux,
        idAtividadeEconomica: this.localSearch.atividadeEconomica.id,
      }).then(page => {
        this.totalCompradorPorAtividadeEconomica.series = page.elements.map(item => item.quantidade || 0);
        this.totalCompradorPorAtividadeEconomica.chartOptions.labels = page.elements.map(item => item.descricao || '');
        // Adiciona o evento de clique
        this.totalCompradorPorAtividadeEconomica.chartOptions.chart.events = {
          dataPointSelection: function(event, chartContext, config) {
            const setor = config.w.config.labels[config.dataPointIndex];
            if (self && typeof self.$refs.comboSetor.search === 'function') {
              self.$refs.comboSetor.searchInput = setor;
              self.$refs.comboSetor.search();
            }
          }
        };      
        this.$refs.totalCompradorPorAtividadeEconomica.updateOptions({
          ...this.totalCompradorPorAtividadeEconomica.chartOptions,
          series: this.totalCompradorPorAtividadeEconomica.series,
        }, true);
      }).catch(err => {
        console.log("Erro ao carregar gráfico: " + this.totalCompradorPorAtividadeEconomica.tituloGrafico + ". " + err.message);
      }).finally(() => {
        this.totalCompradorPorAtividadeEconomica.isLoading = false;
      });

      this.totalCompradorPorEstado.isLoading = true;
      findGraficoComprador(1, {
        tipoSaida: 'estado',
        cnpj: this.localSearch.cnpjAux.chave,
        cidade: this.localSearch.cidadeAux.chave,
        estado: this.localSearch.estadoAux,
        idAtividadeEconomica: this.localSearch.atividadeEconomica.id,
      }).then(page => {
        this.totalCompradorPorEstado.series = [{
          name: 'Compradores',
          data: page.elements.map(item => item.quantidade || 0)
        }];
        this.totalCompradorPorEstado.chartOptions.xaxis.categories = page.elements.map(item => item.descricao || '');
        // Adiciona o evento de clique
        this.totalCompradorPorEstado.chartOptions.chart.events = {
          dataPointSelection: function(event, chartContext, config) {
            const estado = config.w.config.xaxis.categories[config.dataPointIndex];
            if (self) {
              self.localSearch.estadoAux = estado;
            }
          }
        };
        this.$refs.totalCompradorPorEstado.updateOptions({
          ...this.totalCompradorPorEstado.chartOptions,
          series: this.totalCompradorPorEstado.series,
        }, true);
      }).catch(err => {
        console.log("Erro ao carregar gráfico: " + this.totalCompradorPorEstado.tituloGrafico + ". " + err.message);
      }).finally(() => {
        this.totalCompradorPorEstado.isLoading = false;
      });
      
      this.totalCompradorPorCidade.isLoading = true;
      findGraficoComprador(1, {
        tipoSaida: 'cidade',
        cnpj: this.localSearch.cnpjAux.chave,
        cidade: this.localSearch.cidadeAux.chave,
        estado: this.localSearch.estadoAux,
        idAtividadeEconomica: this.localSearch.atividadeEconomica.id,
      }).then(page => {
        this.totalCompradorPorCidade.series = [{
          name: 'Compradores',
          data: page.elements.map(item => item.quantidade || 0)
        }];
        this.totalCompradorPorCidade.chartOptions.dataLabels.enabled = page.elements.length <= 70;
        this.totalCompradorPorCidade.chartOptions.xaxis.categories = page.elements.map(item => item.descricao || '');
        // Adiciona o evento de clique
        this.totalCompradorPorCidade.chartOptions.chart.events = {
          dataPointSelection: function(event, chartContext, config) {
            const cidade = config.w.config.xaxis.categories[config.dataPointIndex];
            if (self) {
              self.localSearch.cidadeAux.chave = cidade;
              self.localSearch.cidadeAux.valor = cidade;
            }
          }
        };
        this.$refs.totalCompradorPorCidade.updateOptions({
          ...this.totalCompradorPorCidade.chartOptions,
          series: this.totalCompradorPorCidade.series,
        }, true);
      }).catch(err => {
        console.log("Erro ao carregar gráfico: " + this.totalCompradorPorCidade.tituloGrafico + ". " + err.message);
      }).finally(() => {
        this.totalCompradorPorCidade.isLoading = false;
      });
    },
    clearFilters() {
      this.localSearch = {
        cnpjAux: { chave: null, valor: null },
        estadoAux: null,
        cidadeAux: { chave: null, valor: null },
        atividadeEconomica: { id: null, descricao: null },
      };
      // Limpa os campos dos componentes SearchBox
      if (this.$refs.comboCidades) this.$refs.comboCidades.resetValues();
      if (this.$refs.comboAtividadeEconomica) this.$refs.comboAtividadeEconomica.resetValues();
      this.refresh();
    }
  },
  mounted() {
    this.refresh();
  },
}
</script>
<style scoped lang="scss">
.page .is-mobile {
  .content {
    overflow: auto;
    max-height: calc(100vh - 60px);
  }

  ::v-deep {
    .v-data-table__wrapper {
      height: calc(100vh - 97px);
    }
  }
}

.page .content {
  /*border:2px solid green;*/
  overflow: auto;
  max-height: calc(100vh - 50px);
  width: 100%;
  flex: 1;

  ::v-deep {
    .v-data-table__wrapper {
      height: calc(100vh - 157px);
    }
  }
}
.rounded-border {
  border-radius: 8px !important;
  border: 0px !important;
}
.titulo {
  font-size: 1em;
  font-weight: bold;
  color:#167ABC;
}
.sub-titulo {
  font-size: 0.8em;
}
.titulo-grafico {
  font-size: 1em;
  font-weight: bold;
  color:black;
}
.chart-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%; /* Ajuste conforme necessário */
}
</style>